export enum RentalExpenseType {
    RealEstateTaxes = 0,
    Insurance = 1,
    FloodInsurance = 2,
    AssociationFees = 3,
    ManagementFees = 4,
    VacancyAdjustment = 5,
}
